import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { MobileHeaderCard } from '~/components/MobileHeaderCard';
import { useDateLang } from '~/hooks/useDateLang';
import { useTimeFormat } from '~/hooks/useTimeFormat';
import { orderStore, userStore } from '~/stores';
import capitalize from '~/utils/capitalize';

interface HeaderAddressProps {
  className?: string;
  shortTitle?: boolean;
  onClick?: () => void;
}

const HeaderAddress = ({
  className,
  shortTitle,
  onClick,
}: HeaderAddressProps) => {
  const { timeFormat } = useTimeFormat();
  const { locale } = useDateLang();
  const { t } = useTranslation();

  const { args, message } = orderStore.getDeliveryLabel({
    timeFormat,
    locale,
    onlySlot: true,
    onlyTime: shortTitle,
  });

  const caption = (() => {
    if (shortTitle) {
      return args.date || args.time;
    }

    return args.time === '30' ? t(message, args) : args.time;
  })();

  const title = (() => {
    if (shortTitle) {
      return args.time;
    }

    if (!userStore.deliveryAddress) {
      return t('selectDeliveryAddress');
    }

    return userStore.deliveryAddress.type
      ? capitalize(userStore.deliveryAddress.type)
      : userStore.deliveryAddress.shortAddress;
  })();

  const hasAddress = Boolean(userStore.deliveryAddress);

  return (
    <MobileHeaderCard
      observerKey="header.deliveryAddress"
      icon={hasAddress ? 'time' : undefined}
      caption={caption}
      title={title}
      isLoading={
        userStore.deliveryAddressMeta.isLoading || orderStore.isETALoading
      }
      onClick={onClick}
      className={className}
    />
  );
};

export default observer(HeaderAddress);
